Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SharedTransitionType = exports.LayoutAnimationType = void 0;
var LayoutAnimationType = exports.LayoutAnimationType = function(LayoutAnimationType) {
    LayoutAnimationType[LayoutAnimationType["ENTERING"] = 1] = "ENTERING";
    LayoutAnimationType[LayoutAnimationType["EXITING"] = 2] = "EXITING";
    LayoutAnimationType[LayoutAnimationType["LAYOUT"] = 3] = "LAYOUT";
    LayoutAnimationType[LayoutAnimationType["SHARED_ELEMENT_TRANSITION"] = 4] = "SHARED_ELEMENT_TRANSITION";
    LayoutAnimationType[LayoutAnimationType["SHARED_ELEMENT_TRANSITION_PROGRESS"] = 5] = "SHARED_ELEMENT_TRANSITION_PROGRESS";
    return LayoutAnimationType;
}({});
var SharedTransitionType = exports.SharedTransitionType = function(SharedTransitionType) {
    SharedTransitionType["ANIMATION"] = "animation";
    SharedTransitionType["PROGRESS_ANIMATION"] = "progressAnimation";
    return SharedTransitionType;
}({});
